/** @file RUNTIME_FNS: the frozen runtime functions and pose's host helpers an instance calls each frame. */
import { classify } from '@zilo/pose3d-facet/classify';
import type { Classify } from '@zilo/pose3d-facet/contract';
import type { Evaluate } from '@zilo/pose3d-pose/contract';
import { evaluate } from '@zilo/pose3d-pose/evaluate';
import { collectEvents } from '@zilo/pose3d-pose/events/collectEvents';
import { reportEvents } from '@zilo/pose3d-pose/events/reportEvents';
import { updatePlants } from '@zilo/pose3d-pose/events/updatePlants';
import { turnFacing } from '@zilo/pose3d-pose/facing/turnFacing';
import { applyPlants } from '@zilo/pose3d-pose/ik/applyPlants';
import type { Corners } from '@zilo/pose3d-render-core/contract';
import { corners } from '@zilo/pose3d-render-core/corners/corners';
import type { HostedPlace } from '@zilo/pose3d-render-core/place/hostedPlace';
import { place } from '@zilo/pose3d-render-core/place/place';

/**
 * The functions an instance runs per frame; injectable so tests can spy on them. `place` takes the frame's
 * `PoseParams` as its host argument (partTransform, shakeClock: design 22.3); a plain frozen `Place` fits too.
 */
export type RuntimeFns = {
  evaluate: Evaluate; classify: Classify; place: HostedPlace; corners: Corners; turnFacing: typeof turnFacing;
  collectEvents: typeof collectEvents; updatePlants: typeof updatePlants; reportEvents: typeof reportEvents; applyPlants: typeof applyPlants;
};

/** The merged implementations from pose, facet and render-core. */
export const RUNTIME_FNS: RuntimeFns = { evaluate, classify, place, corners, turnFacing, collectEvents, updatePlants, reportEvents, applyPlants };
